<template>
  <b-card
    no-body
    :style="`height: ${componentOptions.cardHeight ? componentOptions.cardHeight : '60vh'};`"
  >
    <b-card-header>
      <b-card-title>Qualification Levels</b-card-title>
    </b-card-header>

    <div
      :style="`height: 80%; overflow-y: scroll; overflow-x: hidden;`"
      class="mx-1"
    >
      <b-overlay v-if="qualificationLevels" :show="isLoading">
        <b-row
          v-for="key in Object.keys(qualificationLevels)"
          :key="key.id"
          class="mb-2 px-1"
        >
          <b-col cols="12">
            <h6>{{ key }}</h6>
          </b-col>
          <b-col cols="12">
            <b-progress
              variant="success"
              :value="qualificationLevels[key]"
              :max="totalQualifications"
              show-value
              animated
            />
          </b-col>
        </b-row>
      </b-overlay>
    </div>
  </b-card>
</template>

<script>
import { sum } from 'lodash'

export default {
  props: ['componentOptions', 'reportData', 'section'],
  data() {
    return {
      isLoading: false,
      qualificationLevels: [],
      totalQualifications: 0,
    }
  },

  watch: {
    reportData(newVal, oldVal) {
      this.updateData(newVal)
    },
  },

  mounted() {
    if (Object.keys(this.reportData).length > 0) {
      this.updateData(this.reportData)
    }
  },
  methods: {
    updateData(newVal) {
      // this.qualificationLevels = newVal.qualifications
      this.qualificationLevels = newVal.statistics.charts[this.section].highest_qualification_count

      // console.log(this.qualificationLevels)
      if (this.qualificationLevels) {
        // this.totalQualifications = sum(
        //   this.qualificationLevels.map(qualification => qualification.value),
        // )
        for (const key in this.qualificationLevels) {
          this.totalQualifications += this.qualificationLevels[key]
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.qualiticationLevel-container {
  height: 120vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
